import { Col, Row } from '@/app/components/Flex/Flex'
import { Text } from '@/app/components/Text/Text'
import { UI, type UIBadgeProps } from '@/app/components/UI/UI'
import type { FunctionalComponent } from 'preact'
import evaPng from '../img/eva.png'
import milanaPng from '../img/milana.png'
import zoePng from '../img/zoe.png'
import styles from './index.module.scss'

const bots: {
  name: string
  descDesktop: string
  descMobile: string
  badge: string
  badgeType: UIBadgeProps['type']
  img: string
  alt: string
  // link: string
}[] = [{
  name: 'Зоя',
  descDesktop: 'Разберёт натальную карту, проверит совместимость и поможет советом.',
  descMobile: 'Разберёт карту, проверит совместимость и даст совет.',
  badge: 'Астролог',
  badgeType: 'violet',
  img: zoePng,
  alt: 'AI астролог Зоя',
  // link: '~/chats?redirect=~/chats/zoe',
}, {
  name: 'Милана',
  descDesktop: 'Расшифрует Матрицу и подскажет, где твои сильные стороны и потенциал.',
  descMobile: 'Расшифрует Матрицу и покажет твои сильные стороны.',
  badge: 'Нумеролог',
  badgeType: 'pink',
  img: milanaPng,
  alt: 'AI нумеролог Милана',
  // link: '~/chats?redirect=~/chats/milana',
}, {
  name: 'Ева',
  descDesktop: 'Ответит на вопросы о любви, сложных ситуациях и будущем с помощью Таро.',
  descMobile: 'Ответит на вопросы о любви, сложных ситуациях и будущем.',
  badge: 'Таролог',
  badgeType: 'orange',
  img: evaPng,
  alt: 'AI таролог Милана',
  // link: '~/chats?redirect=~/chats/eva',
}]

export const Bots: FunctionalComponent = () => {
  return (
    <UI.Wrapper>
      <Row gap={30}>
        <UI.Holder maxWidth={600}>
          <Row
            gap={30}
            gapMobile={15}
          >
            <Text
              as='h2'
              fontSize={34}
              fontSizeMobile={24}
              lineHeight={1}
              fontWeight={500}
              textAlign='center'
            >
              AI-эксперты
            </Text>

            <Text
              as='p'
              fontSize={20}
              fontSizeMobile={16}
              lineHeight={1.25}
              textAlign='center'
            >
              Помогут разобраться с отношениями,<br />карьерой и жизненными вопросами
            </Text>
          </Row>
        </UI.Holder>

        <UI.Holder>
          <Row
            gap={20}
            gapMobile={15}
          >
            {bots.map(bot => (
              <UI.Panel
                radius='m'
                type='default'
                class={styles.botCard}
                // link={bot.link}
              >
                <Col
                  gap={20}
                  gapMobile={15}
                  alignItems='center'
                >
                  <img class={styles.photo} src={bot.img} alt={bot.alt} />

                  <Row
                    gap={5}
                    class={styles.content}
                  >
                    <Col
                      alignItems='center'
                      justifyContent='space-between'
                    >
                      <Text
                        as='h3'
                        fontSize={20}
                        fontSizeMobile={16}
                        fontWeight={600}
                      >
                        {bot.name}
                      </Text>

                      <UI.Badge
                        upper
                        size='s'
                        type={bot.badgeType}
                      >
                        {bot.badge}
                      </UI.Badge>
                    </Col>

                    <Text
                      as='p'
                      fontSize={16}
                      fontSizeMobile={14}
                      opacity={0.5}
                      lineHeight={1.25}
                    >
                      <span class='desktop'>
                        {bot.descDesktop}
                      </span>
                      <span class='mobile'>
                        {bot.descMobile}
                      </span>
                    </Text>
                  </Row>
                </Col>
              </UI.Panel>
            ))}

            <Row gap={15} alignItems='center'>
              <UI.Button
                block
                size='l'
                type='primary'
                link='~/chats'
              >
                Задать вопрос
              </UI.Button>

              <UI.Hint>
                Бесплатный старт · Без карты · 1 минута
              </UI.Hint>
            </Row>
          </Row>
        </UI.Holder>
      </Row>
    </UI.Wrapper>
  )
}
